import {IContaContabil} from "@models/contaContabil/contaContabil.ts";
import {ImportDataComponent, ImportDataComponentProps} from "@components/shared/ImportDataComponent.tsx";
import React from "react";
import usePublic from "@shared/hooks/usePublic.ts";
import {useContaContabil} from "@components/contaContabil/hooks/useContaContabil.ts";
import {ICreateContaContabilDto} from "@models/contaContabil/createContaContabilDto.ts";

interface ImportContasContabeisComponentProps {
    onCreate: (v?: IContaContabil[]) => void
}

export function ImportContasContabeisComponent(props: ImportContasContabeisComponentProps) {
    const {onCreate} = props;
    const {getTemplate} = usePublic()
    const {importContasContabeis} = useContaContabil()


    const importProps: ImportDataComponentProps<ICreateContaContabilDto, IContaContabil> = {
        onCreate: onCreate,
        filename: "conta-contabil.csv",
        importMethod: importContasContabeis,
        previewGrid: [{field: 'nome', headerName: 'Nome', width: 100},
            {field: 'codigoReduzido', headerName: 'Código Reduzido', width: 150},
            {field: "nomeCompleto", headerName: 'Nome Completo', width: 200},
        ],
        templateUrl: getTemplate('conta-contabil', 'import-example'),
    }


    return (
        <ImportDataComponent {...importProps}/>
    )
}